import * as __WEBPACK_EXTERNAL_MODULE__encodeBase64_js_87ce3f3b__ from "./encodeBase64.js";
var __webpack_exports__decodeBase64 = __WEBPACK_EXTERNAL_MODULE__encodeBase64_js_87ce3f3b__.decodeBase64;
var __webpack_exports__encodeBase64 = __WEBPACK_EXTERNAL_MODULE__encodeBase64_js_87ce3f3b__.encodeBase64;
export { __webpack_exports__decodeBase64 as decodeBase64, __webpack_exports__encodeBase64 as encodeBase64 };
